import React from "react";
import classNames from "classnames";
import ReactOverlaysModal from "react-overlays/Modal";
import Icon from "./icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const Modal = ({ show, onHide, className, readOnly, children }) => {
  return (
    <ReactOverlaysModal
      show={show}
      onHide={onHide}
      aria-labelledby="modal-label"
      className={classNames("modal", className)}
      renderBackdrop={renderBackdrop}
      onBackdropClick={readOnly ? () => null : onHide}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        {!readOnly && (
          <button type="button" onClick={onHide} className="close-button" aria-label="Close">
            <Icon name="close" />
          </button>
        )}
        <div className="modal__body">{children}</div>
      </>
    </ReactOverlaysModal>
  );
};

export default Modal;
